import { render, staticRenderFns } from "./ProductLabelBulkAttach.vue?vue&type=template&id=417edd0f&scoped=true&"
import script from "./ProductLabelBulkAttach.vue?vue&type=script&lang=js&"
export * from "./ProductLabelBulkAttach.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelBulkAttach.vue?vue&type=style&index=0&id=417edd0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417edd0f",
  null
  
)

export default component.exports